import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Bestellingen',
  buttons: {
    actions: 'Acties',
    [action_create_dummy_order]: 'Testbestelling aanmaken',
    [action_launch_orders_portal_app]: 'Bestellingenportaal openen',
    show_order_details: 'Besteldetails tonen',
    track_order: 'Bestelling volgen',
    update_dropoff_time: 'Aflevertijd bijwerken',
    download_receipt: 'Bon downloaden',
    open_payment_page: 'Betaalpagina openen',
  },
  form: {
    customer_details: {
      placeholder: 'Klantnaam of telefoonnummer invoeren',
    },
    amount_min: {
      placeholder: 'Min. bedrag',
    },
    amount_max: {
      placeholder: 'Max. bedrag',
    },
    utm_source: {
      placeholder: 'UTM-bron invoeren',
    },
    utm_medium: {
      placeholder: 'UTM-medium invoeren',
    },
    utm_campaign: {
      placeholder: 'UTM-campagne invoeren',
    },
    utm_advertisement_id: {
      placeholder: 'UTM-advertentie-ID invoeren',
    },
  },
  labels: {
    no_orders: 'Nog geen bestellingen',
    total_orders: 'Totaal bestellingen',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Ophalen',
    [ORDER_METHODS.delivery]: 'Bezorging',
    [ORDER_METHODS.room_service]: {
      [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Roomservice',
      [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Tafelservice',
    },
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'In behandeling',
    [ORDER_PAYMENT_STATUSES.paid]: 'Betaald',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Gedeeltelijk terugbetaald',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Terugbetaald',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: 'Wacht op goedkeuring',
      [FULFILLMENT_STATUSES.reviewed]: 'Wacht op goedkeuring',
      [FULFILLMENT_STATUSES.accepted]: 'In uitvoering',
      [FULFILLMENT_STATUSES.preparing]: 'In uitvoering',
      [FULFILLMENT_STATUSES.ready]: 'In uitvoering',
      [FULFILLMENT_STATUSES.on_delivery]: 'In uitvoering',
      [FULFILLMENT_STATUSES.picked]: 'Voltooid',
      [FULFILLMENT_STATUSES.rejected]: 'Afgewezen',
      null: 'Onbekend',
      undefined: 'Onbekend',
    },
  },
  tags: {
    dummy: 'TEST',
    pickup: 'Ophalen',
    internal_delivery: 'Interne bezorging',
    external_delivery: 'Externe bezorging',
    room_service: 'Roomservice',
    table_service: 'Tafelservice',
    scheduled: 'Gepland',
    reward: 'Beloning',
    mobile: 'Mobiel',
    invoice: 'Factuur',
    cash: 'Contant',
    rejected_automatically: 'Automatisch afgewezen',
    rejected_manually: 'Handmatig afgewezen',
    call_center: 'Callcenter',
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    tags: 'Tags',
    order_placed: 'Bestelling geplaatst',
    ready_at: 'Bestelling gereed',
    customer: 'Klant',
    items: 'Artikelen',
    method: 'Methode',
    payment_status: 'Betaalstatus',
    fulfillment_status: 'Status',
    total: 'Totaal',
    utm_source: 'UTM Source',
    utm_medium: 'UTM Medium',
    utm_campaign: 'UTM-campagne',
    utm_advertisement_id: 'UTM Advertentie-id',
  },
  metrics: {
    total_orders: 'Totaal bestellingen',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_create_dummy_order: 'Testbestelling aanmaken mislukt',
    dummy_order_created: 'Testbestelling aangemaakt',
    failed_to_launch_orders_portal_app: 'Orderportal starten mislukt',
    failed_to_download_receipt: 'Bon downloaden mislukt',
  },
};
